module.exports = DisabledWidget;

function DisabledWidget() {
  return null;
}
//# sourceMappingURL=index.js.map